import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { CustomIcon } from '~components/index';
import { PERMISSIONS } from '~constants/permissions';
import { useLocalStorage } from '~hooks/index';
import {
  ErrorBoundaryFront,
  InactivityObserver,
  TicsocialWatermark
} from '~layouts/index';
import Sidebar from '../Sidebar/Sidebar';
import { refreshToken } from './UserAuthenticatedRequests';
import './userAuthenticated.scss';

interface TokenDecoded {
  exp: number;
  iat: number;
  jti: string;
  token_type: string;
  user_id: number;
}

const UserAuthenticated = ({ children }: React.PropsWithChildren) => {
  const location = useLocation();
  const windowWidth = window.innerWidth;
  const { appName, userData, userPermissions } = useLocalStorage();
  const includeWorkUnitPermission =
    userPermissions.includes(
      PERMISSIONS.WORK_UNIT.CAN_SWITCH_BETWEEN_WORK_UNIT_VIEWS
    ) && !userData.is_superuser;

  const [isTokenExpired, setIsTokenExpired] = useState<boolean | undefined>(
    true
  );
  const [collapse, setCollapse] = useState(
    windowWidth < 1024 || includeWorkUnitPermission
  );

  const decodeToken = () => {
    const payload = userData?.tokens?.access.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decodedPayload = atob(base64);
    return JSON.parse(decodedPayload) as TokenDecoded;
  };

  const setTokenExpiration = () => {
    if (userData?.tokens?.access) {
      const tokenDecoded = decodeToken();
      const now = Date.now();
      const isExpired = now >= tokenDecoded.exp * 1000;
      return isExpired;
    }
    localStorage.removeItem(appName);
    window.location.replace('/login');
  };

  useEffect(() => {
    const token = setTokenExpiration();
    setIsTokenExpired(token);
    if (token) refreshToken();
  }, []);

  useEffect(() => {
    if (windowWidth < 1024) setCollapse(true);
  }, [location.pathname]);

  return (
    <>
      {!isTokenExpired && (
        <InactivityObserver>
          <div className="userAuthenticated m-0 p-0">
            <TicsocialWatermark />
            {!includeWorkUnitPermission && (
              <div
                className={`userAuthenticated_collapse_btn ${
                  !collapse
                    ? 'userAuthenticated_collapse_btn_sidebar_visible'
                    : ''
                }`}
                onClick={() => setCollapse(!collapse)}
              >
                <CustomIcon name={!collapse ? 'chevronLeft' : 'app_logo'} />
              </div>
            )}

            <Sidebar collapse={collapse} />
            <ErrorBoundaryFront>
              <div className="userAuthenticated_bg">
                <div className="userAuthenticated_content">{children}</div>
              </div>
            </ErrorBoundaryFront>
          </div>
        </InactivityObserver>
      )}
    </>
  );
};

export default UserAuthenticated;
